<mat-dialog-content>
    <h2>Adjustment</h2>
    <mat-label>Inventory ID: {{adjustment!.InventoryID}}</mat-label><br />
    <mat-label>Warehouse: {{adjustment!.WarehouseID}}</mat-label><br />
    <mat-label>Location ID: {{adjustment!.LocationID}}</mat-label><br />
    <mat-label>Lot/Serial Nbr: {{adjustment!.LotSerialNbr}}</mat-label><br />
    <br />
    <mat-label>Current Quantity: {{adjustment!.Quantity}}</mat-label><br />
    <mat-form-field appearance="fill">
        <mat-label>Adjust Quantity To</mat-label>
        <input matInput [(ngModel)]="adjustment!.AdjustQtyTo" inputmode="quantity" autofocus>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button mat-dialog-close tabindex="-1">Cancel</button>
    <button mat-raised-button color="primary" (click)="onConfirmClick()" tabindex="1">OK</button>
</mat-dialog-actions>